import { rgba } from "polished";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ReactComponent as IconTips } from "../images/IconTips.svg";
import {
  Button, color,
  desktop,
  Flex,
  Hidden, mobile, radius,
  shadow,
  SVG, Text,
  View
} from "./Styles";


export const Tips = ({ title, content }) => {
  const { t } = useTranslation();
  const [tipsVisable, setTipsVisable] = useState(false);

  return (
    <Text
      scale={0}
      style={{
        position: "relative",
        display: "inline-flex",
        justifyContent: "center"
      }}
    >
      {tipsVisable && (
        <StyledTipsContent
          z={100}
          px={[1.5, 1.25]}
          py={[1.5, 1.15]}
          bg={rgba(color.black, 0.9)}
          r={radius.lg}
          s={shadow.xl}
        >
          {title && (
            <Text mb={0.75} color={color.white} bold left break paragraph>
              {title}
            </Text>
          )}

          <Flex column gap={0.75}>
            {content.map((p, i) => (
              <Text
                key={i}
                scale={-1}
                color={rgba(color.white, 0.75)}
                left
                paragraph
              >
                {p}
              </Text>
            ))}
          </Flex>

          <Hidden desktop mt={1.25}>
            <Button primary fullWidth onTouchEnd={() => setTipsVisable(false)}>
              {t("好的")}
            </Button>
          </Hidden>
        </StyledTipsContent>
      )}

      <SVG
        svg={IconTips}
        fill={color.tealBlue}
        height={1}
        onMouseEnter={() => setTipsVisable(true)}
        onMouseLeave={() => setTipsVisable(false)}
        onTouchEnd={() => setTipsVisable(true)}
      />
    </Text>
  );
};

const StyledTipsContent = styled(View)`
  ${mobile`
    position: fixed;
    top: 50%;
    right: 2em;
    left: 2em;
    transform: translateY(-50%);
  `}

  ${desktop`
    position: absolute;
    top: 0;
    transform: translateY(calc(-100% - 0.5em));
    width: 20em;
  `}
`;
